<template>
  <div class="notification">
    <v-bottom-sheet v-model="sheet">
      <template v-slot:activator="{ on }">
        <v-card flat class="d-flex flex-column">
          <v-card-actions flat class="px-4 py-0" v-on="on">
            <v-icon id="support-open">
              mdi-help-circle
            </v-icon>
          </v-card-actions>
        </v-card>
      </template>
      <v-card class="px-3">
        <v-row class="mb-3">
          <v-col cols="2">
            <v-btn icon @click="sheet = !sheet"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
          <v-col class="d-flex align-center headline justify-center ma-0 text-center">
            {{ $t('loginPage.support') }}
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
        <v-card flat>
          <v-list two-line v-for="(contact, index) in contact_info" :key="index">
            <v-list-item @click="contact.action">
              <v-list-item-icon>
                <v-icon color="primary">{{ contact.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>{{ $t(`${contact.type}`) }}</v-list-item-subtitle>
                <v-list-item-title>{{ contact.context }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class OpenItemsNotification extends Vue {
  sheet = false;

  contact_info = [
    {
      type: 'phone',
      context: '075 72 / 763 00',
      icon: 'mdi-phone',
      action: this.call,
    },
    {
      type: 'email',
      context: 'support@kiratik.de',
      icon: 'mdi-email',
      action: this.mail,
    },
  ];

  get prepareNoPhone() {
    return this.contact_info[0].context.replace('/', '').replace(/ /g, '');
  }

  call() {
    window.open(`tel:${this.prepareNoPhone}`, '_self');
  }

  mail() {
    window.open(`mailto:${this.contact_info[1].context}`, '_self');
  }
}
</script>
<style scoped lang="scss">
#support-open {
  position: fixed;
  top: 35px;
  left: 35px;
}
</style>
